import React, { useState, useEffect, useContext } from "react";
import Header from "../../elements/Header";
import { EnvContext } from "../../context/EnvContext";
import Footer from "../../elements/Footer";
import { borderRadius } from "@mui/system";
import FAQ from "../../elements/FAQ";
import { collection, addDoc, getDoc, doc } from "firebase/firestore";
import { useFirestore } from "../../firebase/FirestoreContext";
import config from "../../config";
import FeaturedCarousel_MobileV2 from "../../elements/FeaturedCarousel_MobileV2";
import FeaturedCarousel_DesktopV2 from "../../elements/FeaturedCarousel_DesktopV2";
import useWindowSize from "../../utils/useWindowSize";


const breakpoints = [755]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

const AboutUs = ({ isDevMode }) => {
  const db = useFirestore();

  // get AboutUs from Firebase
  const [aboutUs, setAboutUs] = useState(null);
  const environment = useContext(EnvContext);
  const { width } = useWindowSize();
  const isMobile = width <= 768;

  const collectionPath = environment === "staging" ? config.environment.staging.collectionPath : config.environment.production.collectionPath;

  useEffect(() => {
    const fetchAboutUs = async () => {
      try {
        const userDocRef = doc(db, `${collectionPath}Pages/AboutUs`);
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          // Correctly accessing the field from the document data.
          setAboutUs(userDocSnap.data().page_content);
        } else {
          console.error("No About Us page found.");
        }
      } catch (error) {
        console.error("Error fetching About Us:", error);
      }
    };

    fetchAboutUs();
  }, [db, collectionPath]);

  return (
    <div >
      <Header search={false} />

      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", flexDirection: "column", flex: 1, borderTop: "1px solid black", marginTop: 35 }}>
          <div css={{ maxWidth: "1140px", margin: "0 auto" }}>
            {isMobile && <FeaturedCarousel_MobileV2 featuredCollection={"aboutus"} containerStyles={{ margin: "20px 0" }} />}
            {!isMobile && <FeaturedCarousel_DesktopV2 featuredCollection={"aboutus"} containerStyles={{ margin: "20px 0" }} />}
            <div style={{ padding: "15px" }}>
              <div
                css={{
                  padding: "10px 0 5px 0",
                  fontWeight: 500,
                  fontSize: "0.9rem",
                  [mq[0]]: {
                    fontSize: "1.2rem",
                  }
                }}
                className="ql-editor"
                dangerouslySetInnerHTML={{ __html: aboutUs }}
              />
            </div>
            <div style={{ height: 100 }} />
            <FAQ />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};


export default AboutUs;
